import { render, staticRenderFns } from "./revoke-certificate-popup.component.vue?vue&type=template&id=19e427d5"
import script from "./revoke-certificate-popup.component.ts?vue&type=script&lang=ts&external"
export * from "./revoke-certificate-popup.component.ts?vue&type=script&lang=ts&external"
import style0 from "./revoke-certificate-popup.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports